export function ourSolutionsStickyHolder() {
    const stickyNav = $('.our-solutions-nav');
    const header = $(".header");
    const headerHeight = header.innerHeight();
    const stickyArea = $(".our-solutions-sticky-holder");
    // const stickyNavItem = $('.our-solutions-nav li');
    const stickyNavItem = $('.our-solutions-nav .item');
    const sections = $('.our-solutions-description');
    let scrollTop;
    let topIndent = 30;

    const tabbedSliderNav = stickyNav.find('.tabbed-slider-nav');
    const prevArrow = stickyNav.find('.prev-arrow');
    const nextArrow = stickyNav.find('.next-arrow');
    tabbedSliderNav.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        prevArrow: prevArrow,
        nextArrow: nextArrow,
        focusOnSelect: true,
        mobileFirst: true,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 567,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 5,
                    variableWidth: false
                }
            }
        ]
    });

    stickyNav.on('click', ".item button", function (e) {
        e.preventDefault();

        const target = $(this).data("anchor");

        const anchoredBlock = $("#" + target);
        const headerHeight = header.length ? header.innerHeight() : 0;
        if (anchoredBlock.length) {
            $("html, body").animate({scrollTop: anchoredBlock.offset().top - headerHeight - 25}, 500);
            stickyNavItem.removeClass("active");
            $(this).parent().addClass("active");
        }
    });

    function sticky() {
        scrollTop = $(window).scrollTop();
        let stickyAreaHeight = stickyArea.innerHeight();
        let stickyAreaTop = stickyArea.offset().top;
        let stickyAreaBottom = stickyAreaHeight + stickyAreaTop - headerHeight + topIndent;
        let totalWidth = 0;
        if (scrollTop > stickyAreaTop - headerHeight - topIndent && scrollTop < stickyAreaBottom - headerHeight) {
            stickyArea.addClass('has-fixed-child');
        } else if (scrollTop > stickyAreaBottom - headerHeight) {
            stickyArea.removeClass('has-fixed-child');
        } else {
            sections.removeClass('active');
            stickyNav.find('li').removeClass('active');
            stickyArea.removeClass('has-fixed-child');
        }

        if (stickyArea.hasClass('has-fixed-child')) {
            sections.each(function (index, section) {
                let $this = $(section);
                let itemOffsetTop = $this.offset().top;
                if (scrollTop + headerHeight + topIndent >= itemOffsetTop) {
                    let attr = $this.attr("id");
                    if (!$this.hasClass("active")) {
                        $this.addClass('active');
                        if (stickyNav.find('button[data-anchor="' + attr + '"]').length) {
                            stickyNav.find('button[data-anchor="' + attr + '"]').parent().addClass("active").parents(".slick-slide").prev().find(".item").addClass("prev");
                            let slideIndex = stickyNav.find('button[data-anchor="' + attr + '"]').parents(".slick-slide").index();
                            tabbedSliderNav.slick('slickGoTo', slideIndex);
                        }
                    }
                } else {
                    if ($this.hasClass("active")) {
                        $this.removeClass('active');
                        let attr = $this.attr("id");
                        if (stickyNav.find('button[data-anchor="' + attr + '"]').length) {
                            stickyNav.find('button[data-anchor="' + attr + '"]').parent().removeClass("active").parents(".slick-slide").prev().find(".item").removeClass("prev");
                            let slideIndex = stickyNav.find('button[data-anchor="' + attr + '"]').parents(".slick-slide").index();
                            tabbedSliderNav.slick('slickGoTo', slideIndex - 1);
                        }
                    }
                }
            });
        }
    }

    $(window).on("load scroll resize", function () {
        sticky();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/ourSolutionsStickyHolder.js